(() => {
  const page = document.querySelector('.mel-materials-page');

  if (!page) return;

  const cleanUrl = `${window.location.pathname}${window.location.search}`;

  if (window.location.hash) {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    window.history.replaceState(null, '', cleanUrl);
    window.scrollTo(0, 0);
    window.requestAnimationFrame(() => window.scrollTo(0, 0));
    window.addEventListener('load', () => window.scrollTo(0, 0), { once: true });
  }

  page.querySelectorAll('.mel-materials-jump a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = page.querySelector(link.getAttribute('href'));

      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', cleanUrl);
    });
  });
})();
